export const formatPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumber;
};

export const formatLeadTime = (hours) => {
  if (!hours) return "-";
  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  const parts = [];
  if (days) parts.push(`${days} day${days > 1 ? 's' : ''}`);
  if (remainingHours) parts.push(`${remainingHours} hour${remainingHours > 1 ? 's' : ''}`);
  return parts.join(', ');
};

export const toLocalISOString = (date) => {
  const pad = (num) => num.toString().padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  return `${year}-${month}-${day}`;
};

/**
 * Converts a hex color code to an RGB string format for use in CSS
 * @param {string} hex - Hex color code (e.g. #FF5500)
 * @returns {string} RGB values as comma-separated string (e.g. "255,85,0")
 */
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? 
    `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};